import { Component, ElementRef, Renderer2, TemplateRef, ViewChild, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, AbstractControl, FormBuilder, Validators, FormArray, ValidatorFn} from '@angular/forms';
import { BookService } from '../../services/book.services';
import {NgbTypeahead, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {Observable, Subject, OperatorFunction, BehaviorSubject} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import { trigger } from '@angular/animations';
import { NgbDateFRParserFormatter} from '../../shared/dateformat';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

const maximumWeightPerPallet = 2000;
interface ServiceOption {
  type: string;
  description: string;
  origin: string;
  destination: string;
  price: number;
  expiryDate: string;
}
@Component({
  selector: 'app-getquote',
  templateUrl: './getquote.component.html',
  styleUrls: ['./getquote.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [BookService,    {provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter}, ToastrService]
})

export class GetQuoteComponent {

    private serviceOptionsSubject = new BehaviorSubject<ServiceOption[]>([]);
    serviceOptions$: Observable<ServiceOption[]> = this.serviceOptionsSubject.asObservable();

    public bookingForm: FormGroup; 
    public router: Router;
    public email:AbstractControl;
    public password:AbstractControl;
    public modalRef: NgbModalRef;

    public mainLoading: boolean = true;
    bookEconomyHovered: boolean = false;
    bookExpressHovered: boolean = false;
    showQuote: boolean = false;
    fromLocation:boolean = true;
    toLocation:boolean = true;
    emailQuote: boolean = true; // Hide/Show the email input field
    gotQuoteNo: boolean = true;
    rateWarning:boolean = true;
    isLocationValid: boolean = true;

    minDate:any;
    currentQuote:any;
    bookQuoteHovered: any = []
    packagingTypes: any = [];
    suburbs: any = [];
    job_cost_defaults: any = [];
    model: any;
    totalBookingWeight: number = 0;
    totalBookingPallets: number = 0;
    
  @ViewChild('instance', {static: true}) instance: NgbTypeahead;
  @ViewChild('fromLocationCheck', {static: false}) fromLocationCheck: ElementRef;

  @ViewChild('modalQuote', { static: false }) modalQuote: TemplateRef<any>;
  @ViewChild('modalEmailQuote', { static: false }) modalEmailQuote: TemplateRef<any>;
  
  @ViewChild('searchInput', {static: false}) searchElement: ElementRef;
  @ViewChild('searchButton', {static: false}) buttonElement: ElementRef;
  @ViewChild('searchEmail', {static: false}) emailElement: ElementRef;
  @ViewChild('searchIcon', {static: false}) iconElement: ElementRef;
  
  @ViewChild('quoteInput', {static: false}) qInputElement: ElementRef;
  @ViewChild('quoteButton', {static: false}) qbuttonElement: ElementRef;
  

  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  quote_ref_no : string = '';
  save_quote_id : number;

  constructor(router:Router, private _fb:FormBuilder, private bookService: BookService,
              private modal: NgbModal, private renderer: Renderer2, private toastr: ToastrService, private changeDetectorRef: ChangeDetectorRef) {

    document.getElementById('preloader').classList.add('hide');  
    this.router = router;
    this.getPublicBookingData();
    this.serviceOptions$.forEach(x=>{this.bookQuoteHovered.push(false)});

    this.renderer.listen('window', 'click',(e:Event)=>{
      if(!this.emailQuote){
        if(e.target !== this.searchElement.nativeElement && e.target !== this.buttonElement.nativeElement 
          && e.target !== this.emailElement.nativeElement && e.target !== this.iconElement.nativeElement){
          this.emailQuote=true;
       } 
      }

    //  if(!this.gotQuoteNo){
    //   if(e.target !== this.qInputElement.nativeElement && e.target !== this.qbuttonElement.nativeElement
    //      && e.target !== this.qsearchElement.nativeElement && e.target !== this.icon2Element.nativeElement){
    //     this.gotQuoteNo=true;
    //   }
    //  }
    });
  }


  ngOnInit() {
    this.initBookingFrm();
    this.initSelectedRateFrm();
    this.setMinDate();

    this.bookingForm.valueChanges.subscribe(() => {
      this.validateLocation('pickup');
      this.validateLocation('deliver');
      this.checkQuoteEnabled();
      
      if(this.showQuote){
        //triggers whenever a value is changed in form when get quote button is hidden and quotation is shown
        this.showQuote = false;
        this.rateWarning = true;
        this.selectedRateForm.reset();
        this.emailQuote = true;
      }
    });
    console.log(this.quote_ref_no);
  }

  quoteRates: any[] = [];
  getPublicBookingData() {
    this.bookService.getPublicBookingData().subscribe( data => {
        this.packagingTypes = data['packaging_types'];
        this.suburbs = data['postcodes'];
        this.job_cost_defaults = data['job_cost_defaults'];
        this.quoteRates = data['quote_rates'];
        console.log('public booking data', data);
        this.mainLoading = false;
      });
  }

  initBookingFrm() {   
    this.bookingForm = this._fb.group({
      id:[null],
      is_dg:             [false],
      is_hand_unload:    [false],
      is_trailer_split:  [false],
      has_tailgate:      [false],
      pickup_postcode_id: [null, Validators.required],
      pickup_suburb:      ['', Validators.required],
      deliver_postcode_id:[null, Validators.required],
      deliver_suburb:     ['', Validators.required],
      pickup_date:        [null, Validators.required],      //Note: This will also serve as the expiry date of the quotation

      packagings:         this._fb.array([this.initPackagings()]),
      total_weight:       [0],
      chargeable_pallets: [0],

      control_no: [''],
      quote_reference: [''],
      premise_type_id: [2],
      quote_status_id: [1],
      connote_id: [],
      created_by: [1],
      updated_by: [],
      customer_reg_id: [],
    });
  }

  get pickupPostcodeId(){ return this.bookingForm.get('pickup_postcode_id'); }
  get deliverPostcodeId(){ return this.bookingForm.get('deliver_postcode_id'); }

  /**
   * Sets the minimum selectable date to today.
   */
  setMinDate() {
    const today = new Date();
    this.minDate = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };
  }

  /**
   * Initializes the selected rate form upon creating a quotation
  */
  selectedRateForm: FormGroup;
  initSelectedRateFrm() {
    this.selectedRateForm = this._fb.group({
      quote_rate_id: [],
      service_option: [''],
      est_total_price: [0.00],
      ex_gst: [1],
      email: ['', [Validators.required, Validators.email, this.customEmailValidator()]]  
    });
  }

  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const email = control.value;
      if (email && email.indexOf('@') !== -1) {
        const [, domain] = email.split('@');
        if (domain) {
          // Require at least one dot in the domain and at least two characters after the last dot
          const parts = domain.split('.');
          if (parts.length > 1 && parts[parts.length - 1].length >= 2) {
            return null;  // Valid email
          }
        }
      }
      return { 'invalidEmailFormat': true };  // Invalid email
    };
  }

  get packagings() {
    return this.bookingForm.get('packagings') as FormArray;
  }

  initPackagings() {
    const currencyRegex = '^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$';
    const floatRegex = '^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$'; 
    const intRegex = '^[0-9]{1,6}$';
    const group = this._fb.group({
        id: [null],
        quote_id: [null],
        packaging_type_id: [10, Validators.required],
        packaging_type_name: ['Pallet'],
        quantity: [1 , [Validators.required, Validators.pattern(intRegex)]],
        length: ['', [Validators.required, Validators.pattern(floatRegex)]],
        width: ['', [Validators.required, Validators.pattern(floatRegex)]],
        height: ['', [Validators.required, Validators.pattern(floatRegex)]],
        weight: ['', [Validators.required, Validators.pattern(floatRegex)]],
        total_weight: [0],
        chargeablePallets: [0],
        created_by: [1],
        updated_by: [],
    });
  
    return group;
  }

  /**
   * Creates the payload for getting a quote based on the booking form values.
   * @returns The payload object for the quote request.
   */
  createGetQuotePayload() {
    const formValue = this.bookingForm.value;
    const payload = {
      pickup_postcode_id: formValue.pickup_postcode_id,
      deliver_postcode_id: formValue.deliver_postcode_id, 
      is_dg: formValue.is_dg,
      is_trailer_split: formValue.is_trailer_split,
      is_hand_unload: formValue.is_hand_unload, 
      chargeable_pallets: formValue.chargeable_pallets
    };

    return payload;
  }

  /**
   * Fetches a quote based on the current booking form values.
   */
  getQuoteRate(){
    this.currentQuote = this.bookingForm.value;

    const payload = this.createGetQuotePayload();
    console.log("Get quote payload", payload);
    this.bookService.getQuoteRates(payload).subscribe({
      next: (response: any) => {
        this.processQuoteData(response);
        this.showQuote = true;
        this.rateWarning = true;
        this.emailQuote = true;

        // Reset the selectedRateForm with default values
        this.selectedRateForm.reset({
          quote_rate_id: null,
          service_option: '',
          est_total_price: 0.00,
          ex_gst: 1,
          email: ''
        });
      },
      error: (error: any) => {
        console.error("Error fetching quote rates",error);
      }
    })
  }

  /**
   * Processes the quote data received from the server.
   * @param data The quote data received from the server.
   */
  processQuoteData(data) {
    console.log("Quote rates", data);

    if (data.rates && data.rates.length > 0){
      const initialBook = this.bookingForm.value;
      const quoteData = data.rates[0];

      const serviceOptions: ServiceOption[] = [
        {
          type: 'economy',
          description: '2-3 days working service',
          origin: initialBook.pickup_suburb,
          destination: initialBook.deliver_suburb,
          price: quoteData.economy_total_rate,
          expiryDate: this.getExpiryDateString()
        },
        {
          type: 'express',
          description: 'Next working day or 2-Up service',
          origin: initialBook.pickup_suburb,
          destination: initialBook.deliver_suburb,
          price: quoteData.express_total_rate,
          expiryDate: this.getExpiryDateString()
        }
      ]

      this.serviceOptionsSubject.next(serviceOptions);
    }
  }

  /**
   * Gets the expiry date string from the bookingForm's pickup date for display only.
   * @returns A formatted date string (DD MMM YYYY) or 'Invalid Date' if the date is invalid
   */
  getExpiryDateString() {
    const pickupDate = this.getDateFromNgbDate(this.bookingForm.get('pickup_date').value);
    return pickupDate ? pickupDate.toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: 'numeric' }) : 'Invalid Date';
  }

  /**
   * Converts an NgbDateStruct to a Javascript Date Object
   * @param ngbDate The NgbDateStruct to convert
   * @returns A Date object representing the input date, or null if the input is invalid
   */
  private getDateFromNgbDate(ngbDate: NgbDateStruct) {
    return ngbDate ? new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day) : null;
  }

  /**
   * Handles the change of service option.
   * @param option The selected service option.
   */
  onServiceOptionChange(option: ServiceOption) {
    // Find matching quote_rates 
    const matchingRate = this.quoteRates.find(
      rate =>
        rate.start_postcode_id === this.pickupPostcodeId.value &&
        rate.end_postcode_id === this.deliverPostcodeId.value
    );
    
    this.selectedRateForm.patchValue({
      service_option: option.type,
      est_total_price: option.price,
      quote_rate_id: matchingRate?.id ? matchingRate.id : null
    }, { emitEvent: false });

    // Set rateWarning to false when a rate is selected
    this.rateWarning = false;
  }

  /**
   * Determines if the given service option is exclusive of GST
   * @returns True if set to exclude GST, false otherwise
   */
  isExGst() {
    return this.selectedRateForm.get('ex_gst').value === 1;
  }

  /**
   * Initiates the booking porcess with the selected rate quotation.
   */
  saveQuote(caller) {
    var is_email = false;
    if(caller == 'emailquote'){
        is_email = true;
    }

    if (!this.selectedRateForm.get('service_option').value) {
      this.rateWarning = true;
      return;
    }

    if(caller=='emailquote'){
        const emailControl = this.selectedRateForm.get('email');
        emailControl.markAsTouched();
        
        if (!emailControl.valid) {
            console.log('Email validation failed:', emailControl.errors);
            this.toastr.error('Please enter a valid email address.', 'Error');
            return;
        }
    }else{
        this.selectedRateForm.controls.email.clearValidators();
        this.selectedRateForm.controls.email.updateValueAndValidity();
    };
    
    if (this.selectedRateForm.valid && this.bookingForm.valid) {
        const selectedRateData = this.selectedRateForm.value;
        const bookingData = this.bookingForm.value;

        // Ensure ex_gst has a value
        selectedRateData.ex_gst = selectedRateData.ex_gst ? 1 : 0;

        const payload = {
            ...bookingData,
            ...selectedRateData,
            pickup_date: this.formatDate(bookingData.pickup_date),
            is_email
        };

        console.log("Payload", payload);

        this.bookService.createQuote(payload).subscribe(response=>{
          
            console.log("Created quote response", response);
            this.save_quote_id = response['quote'];
            var error = response['error'];
            
            var msg_success = "We have successfully processed this quotation.";
            var toaster_title = "Quotation Form Success";

 
            if(caller == 'booknow'){console.log(this.save_quote_id);
                if(this.save_quote_id != null){
                    this.router.navigate(['/booking', this.save_quote_id]);
                }else{
                    this.toastr.error('Error encountered processing this quotation. Please try again.', 'Quotation Form Error',{
                        timeOut: 5000,
                        positionClass: 'toast-top-full-width',
                        progressBar: true
                        });
                    this.quote_ref_no = null;
                }
            }else{
                if(error){
                    msg_success = "Error encountered processing this quotation. Please try again.";
                    toaster_title = "Quotation Form Error";
                }else{
                    if(caller == 'emailquote'){
                        msg_success = "We have successfully emailed your quote.";
                        var toaster_title = "Quotation Email Sent";
                    }
                }
    
                if(error){
                    this.toastr.error(msg_success, toaster_title,{
                        timeOut: 5000,
                        positionClass: 'toast-top-full-width',
                        progressBar: true
                        });
                }else{
                    this.toastr.success(msg_success, toaster_title,{
                        timeOut: 5000,
                        positionClass: 'toast-top-full-width',
                        progressBar: true
                        });
                }
            }
                
            // Reset forms
            this.resetForms();
            
            // Reset UI states
            this.showQuote = false;
            this.emailQuote = true;
            this.rateWarning = true;
        });
    } else {
        console.error("Form is invalid");
    } 

    
  }

  resetForms() {
    // Reset bookingForm
    this.bookingForm.reset({
      is_dg: false,
      is_hand_unload: false,
      is_trailer_split: false,
      has_tailgate: false,
      pickup_date: new Date(),
      premise_type_id: 2,
      quote_status_id: 1,
      created_by: 1,

      pickup_postcode_id: null,
      pickup_suburb: '',
      deliver_postcode_id: null,
      deliver_suburb: ''
    });

    // Reset the actual input elements
    this.resetTypeaheadInput('pickup-typeahead');
    this.resetTypeaheadInput('delivery-typeahead');
  
    // Reset packagings FormArray
    while (this.packagings.length !== 0) {
      this.packagings.removeAt(0);
    }
    this.addPackaging(); // Add one initial packaging
  
    // Reset selectedRateForm
    this.selectedRateForm.reset({
      ex_gst: 1
    });
  
    // Reset other properties
    this.totalBookingWeight = 0;
    this.totalBookingPallets = 0;
    this.currentQuote = null;
  
    // Reset service options
    this.serviceOptionsSubject.next([]);

    // Reset location flags
    this.fromLocation = true;
    this.toLocation = true;
    this.isLocationValid = true;

    // Force change detection to update view
    this.changeDetectorRef.detectChanges();
  }

  private resetTypeaheadInput(id: string) {
    const inputElement = document.getElementById(id) as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
  }

  /**
   * Formats a NgbDateStruct into a string representation (YYYY-MM-DD).
   * @param date The NgbDateStruct to format
   * @returns The formatted date string, or an empty string if the date is invalid
   */
  private formatDate(date: NgbDateStruct) {
    if (date && date.year && date.month && date.day) {
      return `${date.year}-${date.month.toString().padStart(2, '0')}-${date.day.toString().padStart(2, '0')}`;
    }
    return '';
  }
  
  addPackaging() {
    // add address to the list
    console.log('adding additional packaging');
    const pCtrl = (<any>this.bookingForm).controls.packagings;


    pCtrl.push(this.initPackagings());
    let index = pCtrl.length - 1;
  }  // END ADD ADDRESS


  removePackaging(i: number) {
    // remove address from the list
    const pCtrl = (<any>this.bookingForm).controls.packagings;
    pCtrl.removeAt(i);

    this.computeTotalChargeablePallets();
    this.computeTotalWeight();
  }
  // END REMOVE PACKAGINGS

  onPackagingTypeChange(event: Event, index: number) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedId = Number(selectElement.value);
    const selectedType = this.packagingTypes.find(type => type.id == selectedId);
    
    if (selectedType) {
      const packagingItem = this.packagings.at(index);
      packagingItem.patchValue({
        packaging_type_id: selectedId,
        packaging_type_name: selectedType.name
      });
    }
  }


  assignTotalWeight(i: number) {
  console.log('assigning...');
      // remove address from the list
      const pCtrl = (<any>this.bookingForm).controls.packagings.controls[i];
      if (pCtrl.controls['weight'].value)
          var weight = parseFloat(pCtrl.controls['weight'].value);
      else var weight = 0;

      if (pCtrl.controls['quantity'].value)
          var quantity = parseInt(pCtrl.controls['quantity'].value);
      else var quantity = 0;



      if (quantity && weight) {
          console.log('both has value');
          var itemWeight = quantity * weight;
          pCtrl.controls['total_weight'].setValue(parseFloat(itemWeight.toFixed(2)));

          this.computeTotalWeight();
          this.computeTotalChargeablePallets();
      }
  }

  computeTotalWeight(){
    const pCtrl = (<any>this.bookingForm).controls.packagings.controls;
    var total_weight = 0;
    pCtrl.forEach((item) => {
      total_weight = total_weight + item.controls.total_weight.value;
    });
        
    this.totalBookingWeight = parseFloat(total_weight.toFixed(2));
    this.bookingForm.controls.total_weight.setValue(this.totalBookingWeight);
  }


  // computeTotalChargeablePallets() {
  // console.log('computing pallets')
  // const pCtrl = (<any>this.bookingForm).controls.packagings;
  // var totalChargeablePallets = 0;

  
  // pCtrl.controls.forEach((element, index) => {
  //   console.log('iterating pallets');
  //   console.log(element.controls.length.value,element.controls.width.value,element.controls.height.value)
  //   if (element.controls.length.value && element.controls.width.value && element.controls.height.value) {
  //     var volume = (element.controls.length.value/100) * (element.controls.width.value/100) * (element.controls.height.value/100);
  //     console.log('volume',volume);
  //     var cubicWeight = volume * 333;
  //     var chargeWeight = cubicWeight;
  //     if (element.controls.total_weight > cubicWeight) chargeWeight = element.controls.total_weight;
  //     console.log(chargeWeight);
  //     var chargeablePallets = chargeWeight / maximumWeightPerPallet;
  //     element.controls.chargeablePallets.setValue(chargeablePallets);
  //     console.log(volume,cubicWeight,chargeWeight,chargeablePallets);
  //     totalChargeablePallets = totalChargeablePallets + chargeablePallets;
  //   } else console.log('not valid for pallet computation')
  // });

  // console.log('original pallet', totalChargeablePallets);
  // if (totalChargeablePallets % 1 > 0) totalChargeablePallets = parseInt(totalChargeablePallets.toString()) + 1;
  // console.log('modulo pallet', totalChargeablePallets);
  // this.totalBookingPallets = totalChargeablePallets;
  // }

  public totalChargeablePallets =0; 
  public totalWeightKg =0; 
  public pallet_units:  number = 0;
  public total_qty :number= 0;
  public is_unit_auto_compute = true;
  

  computeTotalChargeablePallets(){
    const pCtrl = (<any>this.bookingForm).controls.packagings.controls;
      this.totalChargeablePallets = 0;
      this.totalWeightKg = 0;
      this.pallet_units = 0;
      this.total_qty = 0;
      var cubic_weight_param = 333;
      if(this.job_cost_defaults[0].cubic_weight_param != null){
        cubic_weight_param = this.job_cost_defaults[0].cubic_weight_param;
      }
    
      pCtrl.forEach((item) => {
        
        if(item.controls.length.value && item.controls.width.value && item.controls.height.value && item.controls.quantity.value && item.controls.weight.value) {
          if(item.controls.quantity.value){this.total_qty += parseFloat(item.controls.quantity.value)};
          var volume = item.controls.quantity.value * ( (item.controls.length.value/100) * (item.controls.width.value/100) * (item.controls.height.value)/100 );
          var cubicWeight = volume * cubic_weight_param;
          var physicalWeight = item.controls.total_weight.value;
          var chargeWeight = Math.max(physicalWeight,cubicWeight);
          var chargeablePallets = chargeWeight / 1000;
          item.controls.chargeablePallets.setValue(chargeablePallets);
          this.totalChargeablePallets = this.totalChargeablePallets + chargeablePallets;
    
          var tonne_weight = item.controls.weight.value/1000;
          this.totalWeightKg = this.totalWeightKg + tonne_weight;
        }
      });
      
      if(this.totalChargeablePallets > 0)
      {
        this.totalChargeablePallets = parseFloat(this.totalChargeablePallets.toFixed(2));
      } 
      
      this.totalChargeablePallets = Math.ceil(this.totalChargeablePallets);

      this.totalBookingPallets = this.total_qty;  
      if(this.totalChargeablePallets > this.total_qty){
        this.totalBookingPallets = this.totalChargeablePallets;  
      }

      this.bookingForm.get('chargeable_pallets').setValue(this.totalBookingPallets);
  };

  getPackagingControl() {
    const pCtrl = (<any>this.bookingForm).controls.packagings;

    return pCtrl.controls;
  }

  showPackagingRemoveIcon() {
    if (this.getPackagingControl().length > 1)
        return true;
    else return false;
  }

  /**
   * Formats the suburb object for display in the typeahead
   * @param suburb An object containing the suburb name and SSC code
   * @returns The name of the suburb as string
   */
  formatter = (suburb: { name: string, ssc_code: number }) => suburb.name;

  /**
   * Defines the search functionality for the suburb typeahead
   * @param text$ An Observable of the search text input by the user
   * @returns An Observable of an array of suburb objects that match the search term
   */
  suburbSearch: OperatorFunction<string, readonly { name: string, ssc_code: number }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.suburbs.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )

  /**
   * Handles the selection of a suburb from the typeahead
   * @param event The selection suburbs details
   * @param type Indicates whether this is for pickup or delivery
   */
  onSuburbSelected(event: any, type: 'pickup' | 'deliver') {
    const selectedSuburb = event.item;
    console.debug("Selected Suburb", selectedSuburb);
    
    this.bookingForm.patchValue({
      [`${type}_postcode_id`]: selectedSuburb.ssc_code,
      [`${type}_suburb`]: selectedSuburb.name,
    });

    this.bookingForm.get(`${type}_postcode_id`).markAsTouched();
    this.bookingForm.get(`${type}_suburb`).markAsTouched();
    
    this.validateLocation(type);
    this.checkQuoteEnabled();
  }

  /**
   * Handles the blur event for pickup and delivery input fields
   * @param type Indicates whether the blurred field is 'pickup' or 'deliver'
   */
  onBlur(type: 'pickup' | 'deliver') {
    const suburbControl = this.bookingForm.get(`${type}_suburb`);
    const postcodeControl = this.bookingForm.get(`${type}_postcode_id`);

    suburbControl.markAsTouched();
    postcodeControl.markAsTouched();

    if (!suburbControl.value) {
      suburbControl.setErrors({'required': true});
      postcodeControl.setErrors({'required': true});
    }

    this.validateLocation(type);
    this.checkQuoteEnabled();
  }

  /**
   * Validates the location (pickup or delivery) based on the current form values
   * Updates relevant flags (fromLocation, toLocation, isLocationValid)
   * @param type Indicates whether to validate pickup or delivery location
   */
  validateLocation(type: 'pickup' | 'deliver') {
    const pickupPostcode = this.bookingForm.get('pickup_postcode_id')?.value;
    const deliverPostcode = this.bookingForm.get('deliver_postcode_id')?.value;

    switch (type) {
      case 'pickup': {
        const pickupSuburb = this.bookingForm.get('pickup_suburb')?.value;
        const isPickupSuburbValid = this.suburbs.some(suburb => suburb.name === pickupSuburb);
        this.fromLocation = isPickupSuburbValid && !!pickupPostcode;
        break;
      }
      case 'deliver': {
        const deliverSuburb = this.bookingForm.get('deliver_suburb')?.value;
        const isDeliverySuburbValid = this.suburbs.some(suburb => suburb.name === deliverSuburb);
        this.toLocation = isDeliverySuburbValid && !!deliverPostcode;
        break;
      }
    }

    this.isLocationValid = this.fromLocation && this.toLocation && pickupPostcode !== deliverPostcode;
  }

  /**
   * Checks if the Get Quote button should be enabled based on form and location validation
  */
  isQuoteEnabled: boolean = false;
  checkQuoteEnabled() {
    this.isQuoteEnabled = this.bookingForm.valid && this.isLocationValid && this.fromLocation && this.toLocation;
  }

  ratefunc(i){
    this.rateWarning=false
    this.currentQuote.selectedRate = i;
    console.debug("Selected Rate", this.currentQuote.selectedRate);
    
  }

  test(row){ //send quote to email
    console.log("email me this quote", row);
    
  }

  refreshPage(){
    location.reload();
  };

  getQuote(){
    if(this.qInputElement.nativeElement.value){
      var quote_ref = this.qInputElement.nativeElement.value;
      this.bookService.getQuoteByClientReference(quote_ref).subscribe(data=>{console.log(data);
        this.initBookingFrm();
        this.populateBookingForm(data['quote'][0]);
        
      });
    }
  };

  populateBookingForm(quote){
    this.bookingForm.controls.id.setValue(quote['id']);
    this.bookingForm.controls.is_dg.setValue(quote['is_dg']);
    this.bookingForm.controls.is_hand_unload.setValue(quote['is_hand_unload']);
    this.bookingForm.controls.is_trailer_split.setValue(quote['is_trailer_split']);
    this.bookingForm.controls.has_tailgate.setValue(quote['has_tailgate']);
    this.bookingForm.controls.pickup_postcode_id.setValue(quote['pickup_postcode_id']);
    this.bookingForm.controls.pickup_suburb.setValue(quote['pickup_suburb']);
    this.bookingForm.controls.deliver_postcode_id.setValue(quote['deliver_postcode_id']);
    this.bookingForm.controls.deliver_suburb.setValue(quote['deliver_suburb']);
    this.bookingForm.controls.pickup_date.setValue(quote['pickup_date']);
    this.bookingForm.controls.total_weight.setValue(quote['total_weight']);
    this.bookingForm.controls.chargeable_pallets.setValue(quote['chargeable_pallets']);
    this.bookingForm.controls.control_no.setValue(quote['control_no']);
    this.bookingForm.controls.quote_reference.setValue(quote['quote_reference']);
    this.bookingForm.controls.premise_type_id.setValue(quote['premise_type_id']);
    this.bookingForm.controls.quote_status_id.setValue(quote['status_id']);
    this.bookingForm.controls.connote_id.setValue(quote['connote_id']);
    this.bookingForm.controls.created_by.setValue(quote['created_by']);
    this.bookingForm.controls.updated_by.setValue(1);
    this.bookingForm.controls.customer_reg_id.setValue(quote['customer_reg_id']);

    this.populatePackagingForm(quote['packagings']);
    this.populateRateForm();
    console.log(this.bookingForm.value)
  };

  populatePackagingForm(packagings){
    const pCtrl = (<any>this.bookingForm).controls.packagings;
    var transformed_packagings = [];

    packagings.forEach((item)=>{
      var packaging = this.initPackagings();
      packaging.controls.id.setValue(item['id']);
      packaging.controls.quote_id.setValue(item['quote_id']);
      packaging.controls.packaging_type_id.setValue(item['packaging_type_id']);
      packaging.controls.packaging_type_name.setValue(item['packaging_type_name']);
      packaging.controls.quantity.setValue(item['quantity']);
      packaging.controls.length.setValue(item['length']);
      packaging.controls.width.setValue(item['width']);
      packaging.controls.height.setValue(item['height']);
      packaging.controls.weight.setValue(item['weight']);
      packaging.controls.total_weight.setValue(0);
      packaging.controls.chargeablePallets.setValue(0);
      packaging.controls.created_by.setValue(item['created_by']);
      packaging.controls.updated_by.setValue(item['updated_by']);

      transformed_packagings.push(packaging);
    });
    console.log(transformed_packagings);
    this.bookingForm.controls.packagings.patchValue(transformed_packagings);
    this.computeTotalChargeablePallets();
    this.computeTotalWeight();
  };

  populateRateForm(){
  }

  goToBooking(caller) {
    if(caller == 'igotquote'){
        this.bookService.getQuoteByClientReference(this.quote_ref_no).subscribe(data=>{
            var quote = data['quote'];
            var is_expired = data['has_expired'];
            var is_booked = data['has_booked'];
            if(quote?.length > 0){
              if(!is_booked && !is_expired){
                var quote_id = quote[0].id;
                this.router.navigate(['/booking', quote_id]);
              }else{
                if(is_booked){
                  this.toastr.info('You can request for another quotation.', 'Quote reference has been booked.',{
                    timeOut: 5000,
                    positionClass: 'toast-top-full-width',
                    progressBar: true
                    });
                  this.quote_ref_no = null;
                }else{
                  if(is_expired){
                    this.toastr.info('You can request for another quotation.', 'Quote reference has expired.',{
                      timeOut: 5000,
                      positionClass: 'toast-top-full-width',
                      progressBar: true
                      });
                    this.quote_ref_no = null;
                  }
                }
              }
                
            }else{
                this.toastr.info('There was no record for this quote reference #. Please try again or you can request for another quotation.', 'Quote reference # not found.',{
                    timeOut: 5000,
                    positionClass: 'toast-top-full-width',
                    progressBar: true
                    });
                this.quote_ref_no = null;
            }
        })
    }
    else if(caller == 'booknow'){
      this.saveQuote(caller);
    }
    
    
  }

} // end export BookModule


export function emailValidator(control: FormControl): {[key: string]: any} {
    var emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;    
    if (control.value && !emailRegexp.test(control.value)) {
        return {invalidEmail: true};
    }
}
